import React from 'react'
import Footers from '../components/Footers/Footers'
import Main from '../components/MainSection/Main'
import Header from '../components/Header/Header'
const LandingPage = () => {
  return (
    <div>
        <Header />
        <Main />
        <Footers />
    </div>
  )
}

export default LandingPage